import React from 'react'
import { Link } from 'react-router-dom'
import Layout from '../layout/Layout'
import SEO from '../components/SEO'

function About() {
  return (
    <Layout>
      <SEO
        title="About Papreja Tech Solutions | Thoughtful Digital Work"
        description="Learn how Papreja Tech Solutions turns ambitious ideas into useful, dependable digital experiences for growing businesses."
        path="/about"
      />
      <main className="overflow-hidden bg-slate-50 dark:bg-slate-950">
        <section className="relative bg-[#071a3d] text-white">
          <div className="absolute inset-0 bg-gradient-to-br from-[#071a3d] via-[#0b2d63] to-[#123f7a]" />
          <div className="relative mx-auto grid max-w-7xl items-center gap-10 px-5 py-16 sm:px-8 sm:py-20 lg:grid-cols-[1fr_0.9fr] lg:px-10 lg:py-24">
            <div className="max-w-2xl">
              <span className="inline-flex rounded-full border border-cyan-300/30 bg-cyan-300/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.2em] text-cyan-300">
                About Papreja
              </span>
              <h1 className="mt-5 text-4xl font-black leading-tight tracking-tight sm:text-5xl lg:text-6xl">
                Technology should leave people feeling more capable.
              </h1>
              <p className="mt-6 max-w-xl text-base leading-7 text-blue-100 sm:text-lg">
                We help businesses turn ambitious ideas into useful, dependable digital experiences. Our work is thoughtful, practical, and always focused on the people using it.
              </p>
              <Link
                to="/contact"
                className="mt-8 inline-flex rounded-lg bg-cyan-400 px-5 py-3 text-sm font-bold text-[#071a3d] transition hover:-translate-y-0.5 hover:bg-cyan-300"
              >
                Start a conversation <span className="ml-2" aria-hidden="true">-&gt;</span>
              </Link>
            </div>
            <div className="relative mx-auto w-full max-w-lg">
              <div className="absolute -inset-3 rounded-3xl border border-cyan-300/20" />
              <img
                src="https://images.unsplash.com/photo-1556761175-4b46a572b786?auto=format&fit=crop&w=1200&q=85"
                alt="Team collaborating around a table"
                className="relative aspect-[4/3] w-full rounded-2xl object-cover shadow-2xl shadow-slate-950/30"
              />
              <div className="absolute -bottom-5 -left-3 rounded-xl border border-white/15 bg-white/10 px-4 py-3 backdrop-blur-md sm:-left-5">
                <p className="text-2xl font-black text-cyan-300">Good work</p>
                <p className="text-xs text-blue-100">starts with good thinking.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20 lg:px-10">
          <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
            <div>
              <p className="text-sm font-bold uppercase tracking-[0.2em] text-cyan-600 dark:text-cyan-400">Our perspective</p>
              <h2 className="mt-4 text-3xl font-black tracking-tight text-slate-900 dark:text-white sm:text-4xl">Progress is built one useful step at a time.</h2>
            </div>
            <div className="space-y-5 text-base leading-7 text-slate-600 dark:text-slate-300">
              <p>We believe the best technology does more than look impressive. It creates clarity, removes friction, and gives people room to do their best work.</p>
              <p>That is why we listen carefully, explain things plainly, and build with the next chapter in mind. Every project is an opportunity to make something stronger, simpler, and more hopeful than what came before.</p>
            </div>
          </div>

          <div className="mt-14 grid gap-5 sm:grid-cols-3">
            <div className="rounded-2xl border border-slate-200 bg-white p-6 dark:border-slate-800 dark:bg-slate-900">
              <p className="text-4xl font-black text-cyan-500">100%</p>
              <p className="mt-2 text-sm font-semibold text-slate-600 dark:text-slate-300">Focused on your goals</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white p-6 dark:border-slate-800 dark:bg-slate-900">
              <p className="text-4xl font-black text-cyan-500">1:1</p>
              <p className="mt-2 text-sm font-semibold text-slate-600 dark:text-slate-300">Clear, human partnership</p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-white p-6 dark:border-slate-800 dark:bg-slate-900">
              <p className="text-4xl font-black text-cyan-500">∞</p>
              <p className="mt-2 text-sm font-semibold text-slate-600 dark:text-slate-300">Room to grow</p>
            </div>
          </div>
        </section>

        <section className="border-y border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900">
          <div className="mx-auto grid max-w-7xl gap-8 px-5 py-16 sm:px-8 md:grid-cols-3 lg:px-10">
            <div>
              <h2 className="text-xl font-bold text-slate-900 dark:text-white">Stay curious</h2>
              <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-400">We keep learning because better questions lead to better solutions.</p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-slate-900 dark:text-white">Keep it human</h2>
              <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-400">We value honest conversations, shared ownership, and progress you can feel.</p>
            </div>
            <div>
              <h2 className="text-xl font-bold text-slate-900 dark:text-white">Make it matter</h2>
              <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-400">We measure success by the real difference our work makes for your team.</p>
            </div>
          </div>
        </section>
      </main>
    </Layout>
  )
}

export default About
